import { IApiError, ISortBy } from '../../../models/api';
import { ApiService } from '../../../services/api';
import { CONSTANTS } from '../../../utils/constants';
import { getErrorMessages } from '../../../utils/formatters';
import { generateAsyncActionNames } from '../../../utils/helpers';
import { AppDispatch } from '../../type';
import { TableActions } from '../table/table.actions';
import { IDelivery } from '../../../models/delivery';

const { get } = ApiService;

enum DeliveriesEndpoints {
  GET_DELIVERIES = '/Delivery/GetDeliveries',
}

enum DeliveriesActionsEnum {
  GET_DELIVERIES = 'GET_DELIVERIES',
  GET_PACKAGE_IMAGE = 'GET_PACKAGE_IMAGE',
}

export const DeliveriesActionsNames = {
  [DeliveriesActionsEnum.GET_DELIVERIES]: generateAsyncActionNames(
    DeliveriesActionsEnum.GET_DELIVERIES
  ),
  [DeliveriesActionsEnum.GET_PACKAGE_IMAGE]: generateAsyncActionNames(
    DeliveriesActionsEnum.GET_PACKAGE_IMAGE
  ),
};

const Actions = {
  [DeliveriesActionsEnum.GET_DELIVERIES]: {
    START: () => ({
      type: DeliveriesActionsNames.GET_DELIVERIES.START,
    }),
    FULFILLED: (data: IDelivery[]) => ({
      type: DeliveriesActionsNames.GET_DELIVERIES.FULFILLED,
      payload: data,
    }),
    REJECTED: (error: IApiError[] | null) => ({
      type: DeliveriesActionsNames.GET_DELIVERIES.REJECTED,
      payload: error,
    }),
  },
  [DeliveriesActionsEnum.GET_PACKAGE_IMAGE]: {
    START: () => ({
      type: DeliveriesActionsNames.GET_PACKAGE_IMAGE.START,
    }),
    FULFILLED: (data: { url: string }) => ({
      type: DeliveriesActionsNames.GET_PACKAGE_IMAGE.FULFILLED,
      payload: data,
    }),
    REJECTED: (error: IApiError[] | null) => ({
      type: DeliveriesActionsNames.GET_PACKAGE_IMAGE.REJECTED,
      payload: error,
    }),
  },
};

const getDeliveries =
  (
    params?: URLSearchParams,
    sort?: ISortBy[],
    updateTable = true,
    pageNumber: number = CONSTANTS.GRIDS.FIRST_PAGE_NUMBER,
    pageSize?: number | null
  ) =>
  async (dispatch: AppDispatch, getState: any) => {
    dispatch(Actions[DeliveriesActionsEnum.GET_DELIVERIES].START());

    const requestData: any = {
      params,
      headers: {
        'X-Pagination': JSON.stringify({
          PageNumber: pageNumber,
          PageSize:
            pageSize ?? getState()?.table.pageSize ?? CONSTANTS.GRIDS.PAGE_SIZE,
        }),
      },
    };

    if (sort && sort.length) {
      requestData.headers['X-Sorting'] = JSON.stringify({ Sortings: sort });
    }

    try {
      const { data }: any = await get(
        DeliveriesEndpoints.GET_DELIVERIES,
        requestData
      );
      if (!data.isSucceeded) {
        throw Error(JSON.stringify(data.errors));
      }

      const deliveries = data?.content?.deliveries ?? [];
      dispatch(
        Actions[DeliveriesActionsEnum.GET_DELIVERIES].FULFILLED(deliveries)
      );

      if (updateTable) {
        dispatch(
          TableActions.setTableData({
            totalRows: data?.content?.totalCount,
            pageNumber: CONSTANTS.GRIDS.FIRST_PAGE_NUMBER,
          })
        );
      }
      return data;
    } catch (error: any) {
      dispatch(
        Actions[DeliveriesActionsEnum.GET_DELIVERIES].REJECTED(
          getErrorMessages(error)
        )
      );
    }
  };

const getPackageImage = (orderId: number) => async (dispatch: AppDispatch) => {
  dispatch(Actions[DeliveriesActionsEnum.GET_PACKAGE_IMAGE].START());
  try {
    const { data } = await get(`Delivery/GetPackageImage/${orderId}`);
    if (!data.isSucceeded) {
      throw Error(JSON.stringify(data.errors));
    }
    const url = data?.content?.url;
    dispatch(
      Actions[DeliveriesActionsEnum.GET_PACKAGE_IMAGE].FULFILLED({ url })
    );
    return url;
  } catch (error: any) {
    dispatch(
      Actions[DeliveriesActionsEnum.GET_PACKAGE_IMAGE].REJECTED(
        getErrorMessages(error)
      )
    );
    return '';
  }
};

export const DeliveriesActions = {
  getDeliveries,
  getPackageImage,
};
